import { Alert, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useContext } from "react";
import UserContext from "../../../services/Context/UserContext";
import Address from "../../Inputs/Address"
import { LoadingButton } from "@mui/lab";
import API from "../../../services/API";
import useReward from "../utils/useReward";
import RewardCard from "./RewardCard";

export default function RewardForm(){

    const { user } = useContext(UserContext)

    const [status, setStatus] = useState('ready')

    const reward = useReward()

    const [contact, setContact] = useState(user)

    const [message, setMessage] = useState('')


    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        const order = {user: contact, products: [reward]}

        API.post('/rewards/order', order)
            .then(r => {
                setMessage(r.data.message)
                setStatus('success')
            })
            .catch(e => {
                setStatus('error')
                setMessage(e.response?.data?.message)
            })
    }


    if(status === 'success'){

        return <Alert severity='success'>{message}</Alert>
    }


    return reward &&
        
        <form onSubmit={handleSubmit}>
                    
            <Stack spacing={2}>

                <Typography>🎁 Obtenez votre récompense :</Typography>

                <Stack alignItems="center">

                    <RewardCard item={reward} disabled />

                </Stack>
                
                <Typography>Veuillez confirmer vos coordonnées pour obtenir votre récompense :</Typography>

                <TextField 
                    label="Email"
                    type='email'
                    size='small'
                    value={contact.email}
                    onChange={e => setContact({...contact, email: e.target.value})}
                    required
                />
                        
                <Address 
                    value={contact}
                    onChange={data => setContact(data)}
                />

                <LoadingButton
                    loading={status === 'submit'}
                    type='submit'
                    variant='contained'
                >
                    Valider
                </LoadingButton>


                {status === 'error' && 
                    <Alert severity='error'>
                        {message || "Une erreur s'est produite."}
                    </Alert>
                }

            </Stack>

        </form>

}